import React, { useReducer } from 'react';
import { Alert, Grid, Snackbar } from '@mui/material';
import AiTrainingDataFilters from './AiTrainingDataFilters';
import AiTrainingDataResults from './AiTrainingDataResults';
//import PropTypes from 'prop-types';

function AiTrainingDataLibrary() {
    const initialMessageData = {
        showMessage: false,
        message: '',
        isSuccessMessage: null,
    };
    function displayMessageReducer(state, action) {
        //debugger;
        switch (action.type) {
            case 'SHOW_ERROR_MESSAGE':
                return { ...state, ...action.payload };
            case 'SHOW_SUCCESS_MESSAGE':
                return { ...state, ...action.payload };
            case 'RESET':
                return initialMessageData;
            default:
                return state;
        }
    }

    const [displayMessageToUser, dispatchMessageToDisplay] = useReducer(
        displayMessageReducer,
        initialMessageData
    );

    const resetMessageToDisplay = () => {
        dispatchMessageToDisplay({
            type: 'RESET',
        });
    };

    const initialFiltersData = {
        fromTimeStamp: null,
        toTimeStamp: null,
        status: '',
    };
    function filtersReducer(state, action) {
        switch (action.type) {
            case 'SET_FROM_TIMESTAMP':
                return { ...state, fromTimeStamp: action.value };
            case 'SET_TO_TIMESTAMP':
                return { ...state, toTimeStamp: action.value };
            case 'SET_STATUS':
                return { ...state, status: action.value };
            case 'RESET':
                return initialFiltersData;
            default:
                return state;
        }
    }

    const [appliedFiltersData, dispatchFiltersToApply] = useReducer(
        filtersReducer,
        initialFiltersData
    );

    return (
        <>
            <Grid container columnSpacing={2} rowSpacing={2}>
                <AiTrainingDataFilters
                    dispatchMessageToDisplay={dispatchMessageToDisplay}
                    appliedFiltersData={appliedFiltersData}
                    dispatchFiltersToApply={dispatchFiltersToApply}
                />
                <AiTrainingDataResults
                    dispatchMessageToDisplay={dispatchMessageToDisplay}
                    appliedFiltersData={appliedFiltersData}
                />
            </Grid>
            <Snackbar
                open={displayMessageToUser.showMessage}
                autoHideDuration={6000}
                onClose={resetMessageToDisplay}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={resetMessageToDisplay}
                    severity={
                        displayMessageToUser.isSuccessMessage
                            ? 'success'
                            : 'error'
                    }
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {displayMessageToUser.message}
                </Alert>
            </Snackbar>
        </>
    );
}

AiTrainingDataLibrary.propTypes = {};

export default AiTrainingDataLibrary;
